import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enComponents from './locales/en/components.json';
import enMaritime from './locales/en/maritime.json';
import enErrors from './locales/en/errors.json';
import enValidation from './locales/en/validation.json';
import enCertificates from './locales/en/certificates.json';
import enCrew from './locales/en/crew.json';
import enMaintenance from './locales/en/maintenance.json';
import enLogbook from './locales/en/logbook.json';
import enSafety from './locales/en/safety.json';
import enEnvironmental from './locales/en/environmental.json';
import enNavigation from './locales/en/navigation.json';
import enDashboard from './locales/en/dashboard.json';
import enSettings from './locales/en/settings.json';

// Import German translations
import deCommon from './locales/de/common.json';
import deComponents from './locales/de/components.json';
import deMaritime from './locales/de/maritime.json';
import deErrors from './locales/de/errors.json';
import deValidation from './locales/de/validation.json';
import deCertificates from './locales/de/certificates.json';
import deCrew from './locales/de/crew.json';
import deMaintenance from './locales/de/maintenance.json';
import deLogbook from './locales/de/logbook.json';
import deSafety from './locales/de/safety.json';
import deEnvironmental from './locales/de/environmental.json';
import deNavigation from './locales/de/navigation.json';
import deDashboard from './locales/de/dashboard.json';
import deSettings from './locales/de/settings.json';

const resources = {
  en: {
    common: enCommon,
    components: enComponents,
    maritime: enMaritime,
    errors: enErrors,
    validation: enValidation,
    certificates: enCertificates,
    crew: enCrew,
    maintenance: enMaintenance,
    logbook: enLogbook,
    safety: enSafety,
    environmental: enEnvironmental,
    navigation: enNavigation,
    dashboard: enDashboard,
    settings: enSettings,
  },
  de: {
    common: deCommon,
    components: deComponents,
    maritime: deMaritime,
    errors: deErrors,
    validation: deValidation,
    certificates: deCertificates,
    crew: deCrew,
    maintenance: deMaintenance,
    logbook: deLogbook,
    safety: deSafety,
    environmental: deEnvironmental,
    navigation: deNavigation,
    dashboard: deDashboard,
    settings: deSettings,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'components',
      'maritime',
      'errors',
      'validation',
      'certificates',
      'crew',
      'maintenance',
      'logbook',
      'safety',
      'environmental',
      'navigation',
      'dashboard',
      'settings',
    ],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Cache user language in localStorage
      caches: ['localStorage'],
      // localStorage key
      lookupLocalStorage: 'i18nextLng',
    },
    
    // React options
    react: {
      useSuspense: false, // Disable suspense for offline-first maritime app
    },
    
    // Debug mode (disable in production)
    debug: import.meta.env.DEV,
  });

export default i18n;
